import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { responseJobOfferRoute, withdrawApplicationRoute } from '@features/applicant';
import { applicantApplicationsKey } from '@features/applications';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type usePostJobOfferResponseProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const usePostJobOfferResponse = ({
  setErrorText,
}: usePostJobOfferResponseProps) => {
  const client = useQueryClient();
  const signedTemplatesKey = 'signedTemplates';
  const {
    mutate: responseJobOffer,
    isLoading: isRespondingJobOffer,
  } = useMutation({
    mutationFn: (variables: { application_id: number, job_offer_response?: string }) =>
      axiosInstance
        .post(responseJobOfferRoute, variables, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([applicantApplicationsKey]);
        client.invalidateQueries([signedTemplatesKey]);
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
  });

  return {
    responseJobOffer,
    isRespondingJobOffer,
  };
};
